import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

interface ICardProps {
    bgImage1: string,
    bgImageM: string,
    isVertical?: boolean,
    isBottomText?: boolean,
}

const getImgUrl = (p: ICardProps) => {
    const bgImageV = p.bgImageM || p.bgImage1;

    if (bgImageV) {
        return `${p.isVertical ? bgImageV : p.bgImage1}`;
    }

    return '';
};

export const Card = styled.div<ICardProps>`
    flex-direction: ${p => p.isBottomText ? 'column-reverse' : 'column'};
    justify-content: space-between;
    flex-wrap: nowrap;
    width: 100%;
    max-width: ${p => p.isVertical ? '316px' : 'none'};
    height: ${p => p.isVertical ? '360px' : '237px'};
    padding: 0 ${p => p.isVertical ? '24px' : '32px'};
    padding-top: 24px;

    background-color: ${COLORS.white};
    background-image: url(${p => getImgUrl(p)});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left bottom;

    border-radius: ${BorderRadius.OuterBlockRadius};
    overflow: hidden;

    @media (max-width: ${breakePoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const DescriptionWrap = styled.div<{isOnlyText?: boolean, isBottomText?: boolean, isVertical?: boolean}>`
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: ${p => !p.isVertical || p.isBottomText ? '30px' : '0'};

    @media (max-width: ${breakePoints.desktop}) {
        margin-top: ${p => p.isOnlyText ? 'auto' : p.isBottomText ? '20px' : '0'};
        margin-bottom: ${p => p.isOnlyText && p.isBottomText ? '20px' : '0'};
        flex: ${p => p.isOnlyText && p.isBottomText ? '0' : '1'};
    }

    @media (max-width: ${breakePoints.sDesktop}) {
        align-items: stretch;
    }
`;

export const Title = styled.div`
    max-width: 340px;
    margin-bottom: 6px;
    ${FONTS.H4};

    @media (max-width: ${breakePoints.mobile}) {
        ${FONTS.H5};
    }
`;

export const Text = styled.div`
    max-width: 320px;
    ${FONTS.XS};
`;

export const Button = styled(BaseButton)`
    margin-top: 15px;

    @media (max-width: ${breakePoints.sDesktop}) {
        margin-top: auto;
        margin-bottom: 15px;
    }

    @media (max-width: ${breakePoints.mobile}) {
        margin-top: auto;
        width: 100%;
    }
`;

export const ImageWrap = styled.div`
    width: 100%;
    height: 140px;
    justify-content: center;
    align-items: center;
`;

export const Image = styled.img`
    width: 100%;
    max-width: 100%;
    height: auto;
    max-height: 100%;
    object-fit: contain;
`;
